module.exports = __webpack_public_path__ + "img/airplay.f6c202a0.svg";